import { useNavigate } from "react-router-dom";
import { Alert } from "reactstrap";
import Constants from "../../utils/Constants";

const MaintenanceAlert = () => {
  const navigate = useNavigate();

  return (
    <Alert className="w-100" color="warning" style={{ height: 10 }}>
      <div className="d-flex align-items-center h-100 justify-content-between">
        <div>
          <i className="mdi mdi-information-outline mr-2" />
          You are working in maintenance mode.
        </div>
        <div
          className="font-weight-bold cursor-pointer"
          onClick={() =>
            navigate(`/clouds/${Constants.MC_CLOUD_ID}/mc/health-maintenance`)
          }
        >
          Disable
        </div>
      </div>
    </Alert>
  );
};

export default MaintenanceAlert;
